export default "__VITE_ASSET__BIo29ncv__"